module.exports = __webpack_public_path__ + "static/media/motorcycle.0a0528e2.png";